import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const TESTIMONIALS = [{
  initials: 'MG',
  name: 'María G.',
  location: 'Buenos Aires',
  title: 'Bajé 6kg en 8 semanas',
  text: 'Nunca había podido organizarme con la comida. Ahora sé exactamente qué cocinar y ya no vivo improvisando.',
  color: 'bg-combo-green'
}, {
  initials: 'RP',
  name: 'Roberto P.',
  location: 'Córdoba',
  title: 'Bajé el colesterol 40 puntos',
  text: 'Mi médico me felicitó por el cambio. Este kit me simplificó completamente la alimentación.',
  color: 'bg-combo-navy'
}, {
  initials: 'LC',
  name: 'Lucas C.',
  location: 'Rosario',
  title: 'Aumenté 4kg de músculo',
  text: 'Entrenaba bien pero comía cualquier cosa. Las recetas proteicas cambiaron mis resultados.',
  color: 'bg-combo-burgundy'
}];
export function Testimonials() {
  return <section className="py-24 bg-cream-dark" data-id="element-652">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-653">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-654">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-ink mb-4" data-id="element-655">
            Resultados reales de personas reales
          </h2>
        </motion.div>
        <div className="grid md:grid-cols-3 gap-8 mb-12" data-id="element-656">
          {TESTIMONIALS.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white rounded-2xl p-8 shadow-sm border border-ink/5" data-id="element-657">
              <div className="flex items-center gap-4 mb-6" data-id="element-658">
                <div className={`w-12 h-12 rounded-full ${t.color} text-white flex items-center justify-center font-bold text-lg`} data-id="element-659">
                  {t.initials}
                </div>
                <div data-id="element-660">
                  <div className="font-bold text-ink" data-id="element-661">{t.name}</div>
                  <div className="text-sm text-ink-light" data-id="element-662">{t.location}</div>
                </div>
              </div>
              <div className="flex gap-1 mb-4" data-id="element-663">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 text-gold fill-gold" data-id="element-664" />)}
              </div>
              <h4 className="font-serif font-bold text-lg text-ink mb-3" data-id="element-665">
                "{t.title}"
              </h4>
              <p className="text-ink-light leading-relaxed italic" data-id="element-666">
                "{t.text}"
              </p>
            </motion.div>)}
        </div>
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="flex justify-center" data-id="element-667">
          <div className="inline-flex items-center gap-2 bg-white px-6 py-3 rounded-full shadow-sm border border-ink/5 font-medium text-ink text-sm" data-id="element-668">
            <Star className="w-4 h-4 text-gold fill-gold" data-id="element-669" />
            +7000 clientes · Valoración promedio 5.0
          </div>
        </motion.div>
      </div>
    </section>;
}